import type { ProjectConfig } from '../project'

/**
 * osmdev — dev-only verification tenant for the OSM adapter (Option B,
 * Post 4242): renders the REAL Tscheppa data (track 30, routes, POIs,
 * balloons, species) on an OpenStreetMap raster base instead of the
 * photographed tile pyramid. Reached via `?project=osmdev` — no subdomain,
 * not linked anywhere. Doubles as the living example of "one tenant = one
 * config file" with an OSM map source; `projects/udo.ts` (Tschepp's lane)
 * will follow the same shape with track 45.
 */
export const osmdevConfig: ProjectConfig = {
  id: 'osmdev',
  name: 'OSM-Dev (Tscheppa auf OSM)',

  api: {
    artrackUrl: 'https://api-artrack.arkturian.com',
    storageUrl: 'https://api-storage.arkturian.com',
    knowledgeUrl: 'https://knowledge-api.arkturian.com',
    apiKey: 'qrBF699Eaz7qv59ICRSlP8IcmSTZEAhH',
    trackId: 30,
  },

  map: {
    type: 'osm',
    center: { lat: 46.489, lng: 14.274 },
    defaultZoom: 0.5,
    backgroundColor: '#1a1a2e',
  },

  pins: {
    defaultStyle: 'dot',
    categoryIcons: {
      poi: '📍', navigation: '🧭', amenity: '🏪', transport: '🚌',
      nature: '🌲', media: '📸', system: '⚙️',
    },
  },

  theme: {
    primary: '#C4A96A',
    background: '#1A1F16',
    text: '#F7F5F0',
    fontHeading: "'Space Grotesk', system-ui, sans-serif",
    fontBody: "'Inter', system-ui, sans-serif",
    logo: '/logo.svg',
  },

  features: {
    audioGuide: true,
    stories: true,
    kioskMode: false,
    species: true,
    navigation: true,
    routeIntelligence: true,
    threeD: false,
  },

  bounds: {
    minLat: 46.475,
    maxLat: 46.500,
    minLng: 14.250,
    maxLng: 14.295,
  },

  defaultRouteId: 56,
  routeIds: [56, 60, 63, 65],

  tileMap: {
    map: {
      type: 'osm',
      // Pannable window: the gorge area plus a little breathing room. The
      // adapter tile-aligns this at minZoom and synthesizes the pyramid.
      bounds: { minLat: 46.470, maxLat: 46.505, minLng: 14.245, maxLng: 14.300 },
      // osm.org tiles are fine for this dev/demo scope; a licensed provider
      // (MapTiler/Thunderforest/proxy) is the production to-do (Post 4242).
      minZoom: 12,
      maxZoom: 17,
    },
    view: {
      center: { lat: 46.489, lng: 14.274 },
      defaultZoom: 0.5,
      backgroundColor: '#1a1a2e',
    },
    routeStyle: {
      color: '#00FF88',
      darkenFactor: 0.5,
      showOnlySelected: true,
    },
    theme: {
      primary: '#C4A96A',
      routeColor: '#00FF88',
      placeholderImageId: 102998,
    },
  },
}
